import { useEffect, useState } from "react";

export type UserPasswordComplexityType = {
  hasValidLength: boolean;
  hasNumber: boolean;
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  match: boolean;
  hasSpecialCharacter: boolean;
  isValid: boolean;
};
const usePasswordComplexity = ({
  password = "",
  repeatPassword = "",
  checkMatch = true,
  minPasswordLength = 8,
  maxPasswordLength = 32,
}): UserPasswordComplexityType => {
  const [hasValidLength, setValidLength] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasUpperCase, setUpperCase] = useState(false);
  const [hasLowerCase, setLowerCase] = useState(false);
  const [hasSpecialCharacter, setSpecialChar] = useState(false);
  const [match, setMatch] = useState(false);
  const [isValid, setValid] = useState(false);

  useEffect(() => {
    setValidLength(
      password.length >= minPasswordLength &&
        password.length <= maxPasswordLength
        ? true
        : false
    );
    setUpperCase(password.toLowerCase() !== password);
    setLowerCase(password.toUpperCase() !== password);
    setHasNumber(/\d/.test(password));
    setSpecialChar(/[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(password));
    if (checkMatch) {
      setMatch(password === repeatPassword);
    }
    if (password.length > 0) {
      setValid(
        hasValidLength &&
          hasNumber &&
          hasUpperCase &&
          hasLowerCase &&
          hasSpecialCharacter
      );
    }
    // eslint-disable-next-line
  }, [password, repeatPassword]);

  return {
    hasValidLength,
    hasNumber,
    hasUpperCase,
    hasLowerCase,
    match,
    hasSpecialCharacter,
    isValid,
  };
};

export const testPasswordComplexity = ({
  password = "",
  repeatPassword = "",
  checkMatch = true,
  minPasswordLength = 8,
  maxPasswordLength = 32,
}): UserPasswordComplexityType => {
  const hasValidLength =
    password.length >= minPasswordLength && password.length <= maxPasswordLength
      ? true
      : false;
  const hasUpperCase = password.toLowerCase() !== password;
  const hasLowerCase = password.toUpperCase() !== password;
  const hasNumber = /\d/.test(password);
  const hasSpecialCharacter = /[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(
    password
  );
  let match = true;
  let isValid = false;

  if (checkMatch) {
    match = password === repeatPassword;
  }

  if (password.length > 0) {
    isValid =
      hasValidLength &&
      hasNumber &&
      hasUpperCase &&
      hasLowerCase &&
      hasSpecialCharacter;
  }

  return {
    hasValidLength,
    hasNumber,
    hasUpperCase,
    hasLowerCase,
    match,
    hasSpecialCharacter,
    isValid,
  };
};

export default usePasswordComplexity;
